module.exports = __webpack_public_path__ + "img/ИФ-1(А)-001-m.85f01ba3.png";